module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Duplicate-f2226ffcb7ee32f5f3dcd60086ca726e.svg";